.table {
  width: 100%;
  min-width: var(--glass-datagrid-min-width, 100%);
  border-collapse: separate;
  border-spacing: 0;
  font-family: var(--aura-font-sans);
  color: var(--aura-color-global-text-primary);
  table-layout: fixed;
}

.headerRow {
  background: transparent;
}

.headerCell {
  position: relative;
  text-align: left;
  padding: var(--glass-space-datagrid-header, 12px 32px 12px 16px);
  font-weight: var(--aura-font-weight-semibold);
  font-size: 0.875rem;
  color: var(--aura-color-global-text-primary);
  border-bottom: var(--glass-space-datagrid-header-border, 1px) solid
    color-mix(in srgb, var(--aura-color-global-text-secondary) 12%, transparent);
  background: color-mix(
    in srgb,
    var(--aura-color-glass-surface) 86%,
    transparent
  );
  transition:
    background var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    color var(--aura-motion-duration-fast) var(--aura-motion-easing-standard);
  overflow-wrap: anywhere;
}

.headerSortable {
  cursor: pointer;
  user-select: none;
}

.headerSortable:hover {
  background: color-mix(
    in srgb,
    var(--aura-color-global-text-primary) 14%,
    var(--aura-color-glass-surface)
  );
  color: var(--aura-color-global-text-primary);
}

.compact .headerCell {
  padding: var(--glass-space-datagrid-compact-header, 8px 28px 8px 12px);
  font-size: 0.8125rem;
}

.compact .cell {
  padding: var(--glass-space-datagrid-compact-cell, 8px 12px);
  font-size: 0.875rem;
}

.compact .dragHandleCell {
  width: 32px;
  padding-inline: var(--glass-space-datagrid-compact-handle-cell, 6px);
}

.headerCell[aria-sort="ascending"],
.headerCell[aria-sort="descending"] {
  background: color-mix(
    in srgb,
    var(--aura-color-highlight) 24%,
    var(--aura-color-glass-surface)
  );
  color: var(--aura-color-global-text-primary);
}

.headerCell[aria-sort="ascending"] .sortIndicator,
.headerCell[aria-sort="descending"] .sortIndicator {
  color: var(--aura-color-global-text-primary);
}

.row:nth-child(even) {
  background: var(
    --glass-datagrid-row-even-bg,
    color-mix(in srgb, var(--aura-color-global-text-primary) 7%, transparent)
  );
}

.row:hover {
  background: var(
    --glass-datagrid-row-hover-bg,
    color-mix(
      in srgb,
      var(--aura-color-global-text-primary) 12%,
      var(--aura-color-glass-surface)
    )
  );
}

.row[aria-selected="true"],
.row[data-selected="true"] {
  background: var(
    --glass-datagrid-row-selected-bg,
    color-mix(
      in srgb,
      var(--aura-color-highlight) 28%,
      var(--aura-color-glass-surface)
    )
  );
}

.row[aria-selected="true"] .cell,
.row[data-selected="true"] .cell {
  color: var(--aura-color-global-text-primary);
  border-bottom-color: color-mix(
    in srgb,
    var(--aura-color-highlight) 34%,
    transparent
  );
}

.headerCell:focus-visible {
  outline: none;
  box-shadow: var(
    --glass-elev-datagrid-header-focus,
    0 0 0 2px hsl(var(--glass-color-primary) / 0.5)
  );
}

.sortIndicator {
  position: absolute;
  right: var(--glass-space-datagrid-sort-right, 8px);
  top: 50%;
  transform: translateY(-50%);
  font-size: 0.75rem;
  color: var(--aura-color-global-text-secondary);
  opacity: 0;
  transform-origin: center center;
  transition: opacity var(--aura-motion-duration-fast)
    var(--aura-motion-easing-standard);
}

.cell {
  padding: var(--glass-space-datagrid-cell, 12px 16px);
  border-bottom: var(--glass-space-datagrid-cell-border, 1px) solid
    color-mix(in srgb, var(--aura-color-global-text-secondary) 8%, transparent);
  font-size: 0.95rem;
  color: var(--aura-color-global-text-primary);
  background: transparent;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.row {
  background: transparent;
  transition:
    background var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    transform var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    box-shadow var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard);
}

.rowDragging {
  background: color-mix(in srgb, var(--aura-color-highlight) 40%, transparent);
  box-shadow: var(
    --glass-elev-datagrid-row-drag,
    0 12px 32px rgba(15, 23, 42, 0.24)
  );
  position: relative;
  z-index: 5;
}

.dragHandleCell {
  text-align: center;
  width: 40px;
  padding: 0 var(--glass-space-datagrid-handle-cell, 8px);
}

.dragHandle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  padding: 0 var(--glass-space-datagrid-handle, 8px);
  line-height: 1;
  color: color-mix(
    in srgb,
    var(--aura-color-global-text-secondary) 70%,
    transparent
  );
  border-radius: var(--aura-radius-sm);
  transition:
    background var(--aura-motion-duration-fast)
      var(--aura-motion-easing-standard),
    color var(--aura-motion-duration-fast) var(--aura-motion-easing-standard);
}

.dragHandle:focus-visible {
  outline: none;
  box-shadow: var(
    --glass-elev-datagrid-handle-focus,
    0 0 0 2px hsl(var(--glass-color-primary) / 0.45)
  );
}

.dragHandle:active {
  cursor: grabbing;
}

.dragHandleActive {
  background: color-mix(in srgb, var(--aura-color-highlight) 70%, transparent);
  color: var(--aura-color-global-text-primary);
}

.body {
  position: relative;
}
